/* 
--- DEVELOPER WARNING ---
This is a generated file.
Any changes you make to this file will not be saved nor git tracked. 
*/

import poseHand_IconURL from './pose-hand.png';
import poseHand_InsetIconURL from './pose-hand-small-3.svg';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export default {
	name: 
  (
    <FormattedMessage
        defaultMessage="Hand Sensing"
        description="name for the Hand Sensing extension"
        id="extension.poseHand.name"
    />
  ),
	description: 
  (
    <FormattedMessage
        defaultMessage="Sense hand movement with the camera."
        description="description for the Hand Sensing extension"
        id="extension.poseHand.description"
    />
  ),
	iconURL: poseHand_IconURL,
	insetIconURL: poseHand_InsetIconURL,
	tags: ["Dancing with AI","Made by PRG"],
	featured: true,
	extensionId: 'poseHand',
}